var exports = {
  "kL": "container__dToO1w",
  "Qs": "content__U_HvDl",
  "i0": "hideOnDesktop__gkVksq",
};

module.exports = exports;
